import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { availableThemes } from '@root/shared/theme'
import {
  Dialog,
  FadeOverflow,
  PaletteIcon,
  type DialogControlProps,
} from '@root/shared/ui-kit'

import { ThemePalette } from './theme-palette'

import type { ClassNameProps } from '@root/shared/react'

export type Props = {
  triggerRef?: React.RefObject<HTMLElement | null>
} & ClassNameProps &
  DialogControlProps

const dialogsStyles = {
  position: 'absolute',
  right: '6px',
  bottom: 'calc(100% + 6px)',
} as const

export const ThemeDialog = (props: Props) => {
  const { t } = useTranslation()

  return (
    <Dialog.Root open={props.open} onOpenChange={props.onOpenChange}>
      <Body
        style={dialogsStyles}
        describedBy={t('common.theme')}
        onPointerDownOutside={(event) => {
          const target = event.target as Node | null
          if (target && props.triggerRef?.current?.contains(target)) {
            event.preventDefault()
          }
        }}
      >
        <Dialog.Header
          title={
            <Title>
              <PaletteIcon size={18} />
              {t('theme.dialog.title')}
            </Title>
          }
        />
        <Content>
          <ContentInner variant="vertical">
            <ThemePalette themes={availableThemes} />
          </ContentInner>
        </Content>
      </Body>
    </Dialog.Root>
  )
}

const Title = styled.div`
  display: flex;
  align-items: center;

  gap: 8px;
`

const Body = styled(Dialog.PlainBody)`
  z-index: 1;
`

const Content = styled.div`
  width: 560px;
  min-height: 280px;
`
const ContentInner = styled(FadeOverflow)`
  padding-block: 12px;
  padding-inline: 12px;
  height: 100%;
  overflow: auto;
`
